import { render, staticRenderFns } from "./Alos.vue?vue&type=template&id=3b9f2c40&"
import script from "./Alos.vue?vue&type=script&lang=js&"
export * from "./Alos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports